import { generateActions } from '../utils/HttpReducerHelper';
import {
  fundingSearch,
  fundingSearchCompleteApplication,
  fundingSearchMatches,
  fundingSearchActive,
  fundingSearchCompleted,
  fundingSearchShared,
  cancelFundingSearch,
  cancelFundingSearchNewHub,
  deleteBusinessProfile,
  deleteBusinessProfileNewHub,
  OPEN_CANCEL_FUNDING_SEARCH_MODAL,
  CLOSE_CANCEL_FUNDING_SEARCH_MODAL,
  REQUEST_DOWNLOAD_PROFILE_ATTACHMENT,
  REQUEST_FUNDING_MATCHES_REQUIREMENTS,
  REQUEST_FUNDING_SEARCH_DOCUMENTS,
  OPEN_DELETE_BUSINESS_PROFILE_MODAL,
  CLOSE_DELETE_BUSINESS_PROFILE_MODAL,
  requestFundingSearchHelp,
  dismissFundingSearchBanner,
  OPEN_REQUEST_FUNDING_SEARCH_HELP_MODAL,
  CLOSE_REQUEST_FUNDING_SEARCH_HELP_MODAL,
  SET_FUNDING_SEARCH_PROFILE_COMPLETION,
  SET_TRADE_HISTORY_ACCOUNTING_SOLUTION,
  OPEN_DELETE_DIRECTOR_CONFIRMATION_MODAL,
  CLOSE_DELETE_DIRECTOR_CONFIRMATION_MODAL,
} from './types';

export * from './contactDetails/actions';
export * from './dueActivitiesCount/actions';
export * from './match/actions';
export * from './offers/actions';
export * from './offersHistory/actions';
export * from './privacyToggle/actions';
export * from './searchFollowers/actions';
export * from './searchManager/actions';

const fundingSearchActiveHTTPActions = generateActions(fundingSearchActive);
export const requestFundingSearchActive = fundingSearchActiveHTTPActions.request;
export const requestFundingSearchActiveSuccess = fundingSearchActiveHTTPActions.success;
export const requestFundingSearchActiveFailure = fundingSearchActiveHTTPActions.failure;

const fundingSearchCompletedHTTPActions = generateActions(fundingSearchCompleted);
export const requestFundingSearchCompleted = fundingSearchCompletedHTTPActions.request;
export const requestFundingSearchCompletedSuccess = fundingSearchCompletedHTTPActions.success;
export const requestFundingSearchCompletedFailure = fundingSearchCompletedHTTPActions.failure;

const fundingSearchSharedHTTPActions = generateActions(fundingSearchShared);
export const requestFundingSearchShared = fundingSearchSharedHTTPActions.request;
export const requestFundingSearchSharedSuccess = fundingSearchSharedHTTPActions.success;
export const requestFundingSearchSharedFailure = fundingSearchSharedHTTPActions.failure;

export const requestFundingSearch = (fundingSearchId, extraParams) => ({
  type: fundingSearch.request,
  fundingSearchId,
  extraParams,
});
export const requestFundingSearchSuccess = (fundingSearchId, response) => ({
  type: fundingSearch.success,
  fundingSearchId,
  response,
});

export const requestFundingSearchFailure = (error) => ({
  type: fundingSearch.failure,
  error,
});

export const requestFundingSearchCompleteApplication = (payload) => ({
  type: fundingSearchCompleteApplication.request,
  payload,
});

export const requestFundingSearchCompleteApplicationSuccess = () => ({
  type: fundingSearchCompleteApplication.success,
});

export const requestFundingSearchCompleteApplicationFailure = (error) => ({
  type: fundingSearchCompleteApplication.failure,
  error,
});

export const requestFundingSearchMatches = (fundingSearchId) => ({
  type: fundingSearchMatches.request,
  fundingSearchId,
});

export const requestFundingSearchMatchesSuccess = (fundingSearchId, response) => ({
  type: fundingSearchMatches.success,
  fundingSearchId,
  response,
});

export const requestFundingSearchMatchesFailure = (error) => ({
  type: fundingSearchMatches.failure,
  error,
});

export const requestCancelFundingSearch = (fundingSearchId, promise) => ({
  type: cancelFundingSearch.request,
  fundingSearchId,
  promise,
});

export const requestCancelFundingSearchNewHub = (fundingSearchId, promise) => ({
  type: cancelFundingSearchNewHub.request,
  fundingSearchId,
  promise,
});

export const requestCancelFundingSearchSuccess = (fundingSearchId, response) => ({
  type: cancelFundingSearch.success,
  fundingSearchId,
  response,
});

export const requestCancelFundingSearchFailure = (error) => ({
  type: cancelFundingSearch.failure,
  error,
});

export const requestDeleteBusinessProfile = (fundingSearchId, promise) => ({
  type: deleteBusinessProfile.request,
  fundingSearchId,
  promise,
});

export const requestDeleteBusinessProfileNewHub = (businessId, promise) => ({
  type: deleteBusinessProfileNewHub.request,
  businessId,
  promise,
});

export const requestDeleteBusinessProfileSuccess = (fundingSearchId, response) => ({
  type: deleteBusinessProfile.success,
  fundingSearchId,
  response,
});

export const requestDeleteBusinessProfileFailure = (error) => ({
  type: deleteBusinessProfile.failure,
  error,
});

export const openCancelFundingSearchModal = (fundingSearchInstance) => ({
  type: OPEN_CANCEL_FUNDING_SEARCH_MODAL,
  fundingSearch: fundingSearchInstance,
});

export const openDeleteDirectorConfirmationModal = (promise) => ({
  type: OPEN_DELETE_DIRECTOR_CONFIRMATION_MODAL,
  promise,
});

export const closeCancelFundingSearchModal = () => ({
  type: CLOSE_CANCEL_FUNDING_SEARCH_MODAL,
});

export const closeDeleteDirectorConfirmationModal = () => ({
  type: CLOSE_DELETE_DIRECTOR_CONFIRMATION_MODAL,
});

export const requestDownloadProfileAttachment = (fundingSearchId, promise) => ({
  type: REQUEST_DOWNLOAD_PROFILE_ATTACHMENT,
  fundingSearchId,
  promise,
});

export const requestFundingSearchDocuments = (fundingSearchId, payload, promise) => ({
  type: REQUEST_FUNDING_SEARCH_DOCUMENTS,
  fundingSearchId,
  payload,
  promise,
});

export const openRequestFundingSearchHelpModal = (fundingSearchInstance) => ({
  type: OPEN_REQUEST_FUNDING_SEARCH_HELP_MODAL,
  fundingSearch: fundingSearchInstance,
});

export const closeRequestFundingSearchHelpModal = () => ({
  type: CLOSE_REQUEST_FUNDING_SEARCH_HELP_MODAL,
});

export const requestRequestFundingSearchHelp = (fundingSearchId, payload, promise) => ({
  type: requestFundingSearchHelp.request,
  fundingSearchId,
  payload,
  promise,
});

export const openDeleteBusinessProfileModal = (fundingSearchInstance) => ({
  type: OPEN_DELETE_BUSINESS_PROFILE_MODAL,
  fundingSearch: fundingSearchInstance,
});

export const closeDeleteBusinessProfileModal = () => ({
  type: CLOSE_DELETE_BUSINESS_PROFILE_MODAL,
});

export const requestRequestFundingSearchHelpSuccess = (fundingSearchId, response) => ({
  type: requestFundingSearchHelp.success,
  fundingSearchId,
  response,
});

export const requestRequestFundingSearchHelpFailure = (error) => ({
  type: requestFundingSearchHelp.failure,
  error,
});

export const requestFundingSearchBannerDismiss = (fundingSearchId, promise) => ({
  type: dismissFundingSearchBanner.request,
  fundingSearchId,
  promise,
});

export const requestFundingSearchBannerDismissSuccess = (fundingSearchId, response) => ({
  type: dismissFundingSearchBanner.success,
  fundingSearchId,
  response,
});

export const requestFundingSearchBannerDismissFailure = (error) => ({
  type: dismissFundingSearchBanner.failure,
  error,
});

export const setFundingSearchProfileCompletion = (fundingSearchId, completion) => ({
  type: SET_FUNDING_SEARCH_PROFILE_COMPLETION,
  fundingSearchId,
  completion,
});

export function setTradeHistoryAccountingSolution(accountingSolution, fundingSearchId) {
  return {
    type: SET_TRADE_HISTORY_ACCOUNTING_SOLUTION,
    accountingSolution,
    fundingSearchId,
  };
}

export const requestMatchRequirements = (fundingMatchIds, promise) => ({
  type: REQUEST_FUNDING_MATCHES_REQUIREMENTS,
  fundingMatchIds,
  promise,
});
